import { useState } from 'react';
import type { DocumentMeta } from '../../core/types';
import { applyImageSize } from '../../state/actions';
import { Checkbox, Modal, NumberInput } from '../components/controls';

export function ImageSizeDialog({
  doc,
  open,
  onClose,
}: {
  doc: DocumentMeta;
  open: boolean;
  onClose: () => void;
}) {
  const [width, setWidth] = useState(doc.width);
  const [height, setHeight] = useState(doc.height);
  const [linked, setLinked] = useState(true);
  const aspect = doc.width / doc.height;

  const changeWidth = (value: number) => {
    setWidth(value);
    if (linked) setHeight(Math.max(1, Math.round(value / aspect)));
  };

  const changeHeight = (value: number) => {
    setHeight(value);
    if (linked) setWidth(Math.max(1, Math.round(value * aspect)));
  };

  const apply = () => {
    applyImageSize(width, height);
    onClose();
  };

  const percent = Math.round((width / doc.width) * 100);

  return (
    <Modal
      open={open}
      title="Image Size"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="button button--primary" onClick={apply}>
            Apply
          </button>
        </>
      }
    >
      <p className="dialog__note">
        Current size: {doc.width} × {doc.height} px
      </p>
      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          Width
        </span>
        <NumberInput value={width} min={1} max={16384} onChange={changeWidth} width={90} />
        <span className="field__label">px</span>
      </div>
      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          Height
        </span>
        <NumberInput value={height} min={1} max={16384} onChange={changeHeight} width={90} />
        <span className="field__label">px</span>
      </div>
      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          Scale
        </span>
        <NumberInput
          value={percent}
          min={1}
          max={1600}
          onChange={(value) => {
            setWidth(Math.max(1, Math.round((doc.width * value) / 100)));
            setHeight(Math.max(1, Math.round((doc.height * value) / 100)));
          }}
          width={90}
        />
        <span className="field__label">%</span>
      </div>
      <Checkbox label="Constrain proportions" checked={linked} onChange={setLinked} />
      <p className="dialog__note">Resampling is bilinear and runs on the GPU.</p>
    </Modal>
  );
}
